






















import { computed, defineComponent, ref } from '@vue/composition-api';

import DeliveryMap from '@/components/Overall/DeliveryMap.vue';

const ViewDeliveryMarkerModal = defineComponent({
  components: { DeliveryMap },
  props: {
    markers: { type: Array },
    cars: { default: () => [] },
    carStamps: { default: () => [] },
    showDeliveryNumber: { default: false },
    showIndex: { default: false },
    showVehicleLicense: { default: false },
    showOrderNumber: { default: true },
    drawDeliveryDirection: { default: false },
    drawVehicleDirection: { default: false },
    isMapModal: { default: false },
  },
  setup(props, { emit }) {
    const internalActive = ref(false);
    const _active = computed(() => internalActive.value);
    const refetch = ref(false);

    function open() { internalActive.value = true; refetch.value = true; }
    function close() { internalActive.value = false; refetch.value = false; }

    return {
      _active,
      open,
      close,
      refetch,
    };
  },
});

export default ViewDeliveryMarkerModal;
